// extracted by mini-css-extract-plugin
export default {"badge":"styles_badge__qBPXr","offset-primary":"styles_offset-primary__T8LNJ","badge-message":"styles_badge-message__PWns8"};